import { OrmModel, StringField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.TABLE_PAGE_STATE)
export default class TablePageState extends BaseModel {
  @StringField()
  public id: string

  @BooleanField(true)
  public isLoading: boolean
}
